import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const CustomDatePicker = ({onChange}) => {
    const date = new Date();
    date.setMonth(date.getMonth() - 2);

    const handleChange = (val) => {
        if (!val) return onChange([undefined, undefined]);
        onChange(val.map(val => val && Math.floor(val.valueOf() / 1000)))
    };

    return (
        <RangePicker
            defaultValue={[
                moment(date, 'DD.MM.YYYY'),
                moment(new Date(), 'DD.MM.YYYY')
            ]}
            format='DD.MM.YYYY'
            separator='-'
            placeholder={['Սկսած','Մինչեւ']}
            size={'large'}
            style={{width: '100%'}}
            onCalendarChange={handleChange}
        />
    )
};

CustomDatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default CustomDatePicker;